import React from 'react';
import T from 'prop-types';

import AppInfo from './AppInfo';
import Container from '../../../../components/Container';
import useShowMiniHeader from '../../../app-insights/_shared/hooks/useShowMiniHeader';

const MiniHeader = ({ apps, date, isMobileView }) => {
  const scrollRef = useShowMiniHeader(0);

  return (
    <div className="mini-header-wrapper">
      <div className="mini-header" ref={scrollRef}>
        <Container maxWidth={1248}>
          {!isMobileView && apps && apps.length > 0 && (
            <div className="apps-box">
              {apps.map((app, index) => (
                <AppInfo
                  key={index}
                  app={app}
                  size={32}
                  appNameClassName="text-truncate"
                />
              ))}
            </div>
          )}
          <div className="date">
            Updated {date}  •  Trailing 12 Months; 90-Day Lag
          </div>
        </Container>
      </div>
    </div>
  );
};

MiniHeader.propTypes = {
  apps: T.array,
  date: T.string,
  isMobileView: T.bool.isRequired,
};

export default MiniHeader;
